module.exports = __webpack_public_path__ + "0bb9fe38c87884fe5e59e0679d3a660c.png";